export const SORTING = [
  {
    name: 'Pickup Time (Soonest)',
    sortField: 'pickups',
    sortOrder: 'asc',
  },
  {
    name: 'Pickup Time (Latest)',
    sortField: 'pickups',
    sortOrder: 'desc',
  },
  {
    name: 'Delivery Time (Soonest)',
    sortField: 'deliveries',
    sortOrder: 'asc',
  },
  {
    name: 'Delivery Time (Latest)',
    sortField: 'deliveries',
    sortOrder: 'desc',
  },
  {
    name: 'Last Touched (Most Recent)',
    sortField: 'last_action_at',
    sortOrder: 'desc',
  },
  {
    name: 'Last Touched (Least Recent)',
    sortField: 'last_action_at',
    sortOrder: 'asc',
  },
]
